import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Ticket } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Button } from "../components/ui/button";
import BetCard from "../components/BetCard";

const TABS = ["matched", "won", "lost", "cancelled"];

export default function MyBets() {
  const { isAuthed, bets, sessionBets, tossBets } = useApp();
  const [tab, setTab] = useState("matched");

  if (!isAuthed) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-24 text-center">
        <Ticket className="h-10 w-10 mx-auto text-primary mb-4" />
        <h2 className="font-display font-bold text-2xl">Sign in to view your bets</h2>
        <p className="text-muted-foreground mt-2">Your matched bets and history will appear here.</p>
        <Link to="/"><Button className="mt-6 font-semibold">Go Home</Button></Link>
      </div>
    );
  }

  const isOpen = (b) => b.status === "matched" || b.status === "pending" || b.status === "open";
  // Session bets share the same tabs (open → matched, void → cancelled).
  const sessTagged = (sessionBets || []).map((b) => ({ ...b, kind: "session" }));
  const tossTagged = (tossBets || []).map((b) => ({ ...b, kind: "session", isToss: true, sessionName: `Toss · ${b.teamName}`, side: "toss" }));
  const all = [...(bets || []).map((b) => ({ ...b, kind: "match" })), ...sessTagged, ...tossTagged];
  const inTab = (b) => {
    if (tab === "matched") return isOpen(b);
    if (tab === "cancelled") return b.status === "cancelled" || b.status === "void";
    return b.status === tab;
  };
  const filtered = all
    .filter(inTab)
    .sort((a, b) => (b.placedAt || "").localeCompare(a.placedAt || ""));

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-end justify-between mb-5">
        <h1 className="font-display font-extrabold text-3xl">My Bets</h1>
        <span className="text-xs text-zinc-500" data-testid="mybets-count">{filtered.length} {tab}</span>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="mb-5">
        <TabsList className="grid w-full max-w-md grid-cols-4 h-auto bg-[#111318] ring-1 ring-white/[0.07] border-0 rounded-full p-1" data-testid="mybets-tabs">
          {TABS.map((t) => (
            <TabsTrigger key={t} value={t} data-testid={`mybets-tab-${t}`} className="capitalize rounded-full px-2 py-2 min-w-0 truncate text-[11px] sm:text-xs font-bold data-[state=active]:bg-[#f5b400] data-[state=active]:text-black data-[state=active]:shadow-[0_6px_16px_-8px_rgba(245,180,0,0.9)]">{t}</TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {filtered.length === 0 ? (
        <div className="rounded-xl bg-[#111318] ring-1 ring-white/[0.07] p-10 text-center text-sm text-zinc-500">No bets here yet.</div>
      ) : (
        <div className="space-y-2">
          {filtered.map((b) => <BetCard key={b.id} b={b} />)}
        </div>
      )}
    </div>
  );
}
